<template>
  <header class="header bg-white">
    <dicta-header :englishSupported="false" :showPromotions="'word-search'"></dicta-header>
    <div class="bg-primary position-relative">
      <div class="container second-header text-white">
        <div class="row">
          <div class="col-sm-6">
            <div class="logo">
              <div class="text-center d-inline-block bg-white rounded-circle" @click="resetData">
                <img class="" src="../assets/logo.png"  alt=""/>
              </div>  
              <div class="mx-2 d-inline-block">{{hebrew ? 'ביטויים נפוצים' : 'Search'}}</div>
            </div>
          </div>
          <div class="col-sm-6 d-none d-sm-block" :class="{'text-left' : hebrew, 'text-right' : !hebrew}">        
            <b-button variant="primary" class="how-btn btn btn-outline-light btn-primary" size="md" @click="showAbout = true">
              {{hebrew ? 'איך זה עובד' : 'How it works'}}
            </b-button>            
          </div>
        </div>
      </div>
    </div>
      <!--   <keyboard-shortcuts v-model="showShortcuts"></keyboard-shortcuts>        --> 
    <about-dialog v-model="showAbout"></about-dialog>
  </header>
</template>
<script>
  import AboutDialog from '@/components/HowDialog'
  /*import KeyboardShortcuts from '@/components/KeyboardShortcuts' */
  export default  {
    name: 'Header',
    components: {
      AboutDialog
    },
    data() {
      return {
        showAbout: false,
        showShortcuts: false      }   
    },
    mounted () {
    },
    methods: {
      resetData () {
        this.$store.commit('RESET_STATE') 
      }
    },
    computed: {
      hebrew () {
        //return this.$settings.hebrew
        return true
      } 
    }     
  }    
</script>
<style>
  .top-bar{
    margin: 0 auto!important;
    padding: 5px 0;
  }
</style>
<style scoped lang="scss">
  .second-header {
    padding-top: 7px;
    padding-bottom: 7px;    
  }
  .logo {
    font-size: 18px;
    display: flex;
    align-items: center;
    .rounded-circle {
      height: 40px;
      width: 40px;
      cursor: pointer;
      img {
        max-height: 100%;
      }

    }    
  }   
  .how-btn {
      margin-top: 3px; 
  }
</style>